module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "sec-7"
    }
  }, [_c('h1', {
    staticClass: "h1a",
    staticStyle: {
      "margin-bottom": "2.2em",
      "margin-top": "3.7em"
    },
    attrs: {
      "id": "pz7-6"
    }
  }, [_vm._v("\n\t\t\t\t\tContents ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    staticStyle: {
      "margin-top": "0.3em",
      "text-indent": "0"
    },
    attrs: {
      "id": "pz7-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/frontmatter02#pz9-1",
      "id": "d1"
    }
  }, [_c('b', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    staticStyle: {
      "margin-top": "0.3em",
      "text-indent": "0"
    },
    attrs: {
      "id": "Ay3s"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/frontmatter03#pz13-1",
      "id": "d2"
    }
  }, [_c('b', [_vm._v("Foreword")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "A6y"
    }
  }, [_c('i', [_vm._v("Jason Brian Santos")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    staticStyle: {
      "margin-top": "0.3em",
      "text-indent": "0"
    },
    attrs: {
      "id": "Anx"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/frontmatter04#pAn8",
      "id": "d3"
    }
  }, [_c('b', [_vm._v("Introduction:")]), _vm._v(" Addressing the Two Intergenerational Questions")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "Ag4"
    }
  }, [_c('i', [_vm._v("Holly Catterton Allen and Chris Barnett")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    staticStyle: {
      "margin-top": "0.3em",
      "text-indent": "0"
    },
    attrs: {
      "id": "AL4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/frontmatter05#pAL1p",
      "id": "d4"
    }
  }, [_c('b', [_vm._v("Prologue:")]), _vm._v(" Four Stories")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "Aq1"
    }
  }, [_c('i', [_vm._v("Melissa Cooper, Amy Kippen, Aqueelah Ligonde, and Jim Merhaut")])]), _vm._v(" "), _c('p', {
    staticClass: "center",
    staticStyle: {
      "margin-top": "1.5em",
      "margin-bottom": ".5em"
    },
    attrs: {
      "id": "pz7-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/part01#pAtgUl",
      "id": "d5",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("PART ONE"), _c('br'), _vm._v("\n\t\t\t\t\tBecoming More Intentionally Intergenerational")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pz7-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter01#pAbHE",
      "id": "d6",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter One:")]), _vm._v(" Why Now?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "Ans4"
    }
  }, [_c('i', [_vm._v("Jason Brian Santos")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    staticStyle: {
      "margin-top": "0.3em",
      "text-indent": "0"
    },
    attrs: {
      "id": "pz7-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02#pAxtP",
      "id": "d7",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter Two:")]), _vm._v(" Intergenerational Communities and a Theology of Accommodation")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "A0GO"
    }
  }, [_c('i', [_vm._v("Gareth Crispin")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    staticStyle: {
      "margin-top": "0.3em",
      "text-indent": "0"
    },
    attrs: {
      "id": "pz7-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#pAPN_",
      "id": "d8",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter Three:")]), _vm._v(" Learning to Love Together")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "Anq"
    }
  }, [_c('i', [_vm._v("Darwin K. Glassford")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    staticStyle: {
      "margin-top": "0.3em",
      "text-indent": "0"
    },
    attrs: {
      "id": "pz7-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#pAGt_",
      "id": "d9",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter Four:")]), _vm._v(" Generational Theory and Faith Communities")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "AKT"
    }
  }, [_c('i', [_vm._v("Lynn Barger Elliott")])]), _vm._v(" "), _c('p', {
    staticClass: "center",
    staticStyle: {
      "margin-top": "1.5em",
      "margin-bottom": ".5em"
    },
    attrs: {
      "id": "pz7-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/part02#pAsEn",
      "id": "d10",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("PART TWO"), _c('br'), _vm._v("\n\t\t\t\t\tLeading Intergenerational Change")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pz7-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05#pAg34",
      "id": "d11",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter Five:")]), _vm._v(" From "), _c('i', [_vm._v("Multi")]), _vm._v("generational to "), _c('i', [_vm._v("Inter")]), _vm._v("generational")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "APZ"
    }
  }, [_c('i', [_vm._v("Cory Seibel")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    staticStyle: {
      "margin-top": "0.3em",
      "text-indent": "0"
    },
    attrs: {
      "id": "pz7-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter06#pABkg",
      "id": "d12",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter Six:")]), _vm._v(" Intergenerational Principles and Three Stories")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "ALR"
    }
  }, [_c('i', [_vm._v("John Roberto")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    staticStyle: {
      "margin-top": "0.3em",
      "text-indent": "0"
    },
    attrs: {
      "id": "pz7-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter07#pAs3o",
      "id": "d13",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter Seven:")]), _vm._v(" Unlocking the Power of Intergenerational Leadership")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "ALs"
    }
  }, [_c('i', [_vm._v("Jessica Stollings")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    staticStyle: {
      "margin-top": "0.3em",
      "text-indent": "0"
    },
    attrs: {
      "id": "pz7-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter08#pAcYx",
      "id": "d14",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter Eight:")]), _vm._v(" In It for the Long Haul")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "AqQ"
    }
  }, [_c('i', [_vm._v("Joseph P. Conway")])]), _vm._v(" "), _c('p', {
    staticClass: "center",
    staticStyle: {
      "margin-top": "1.5em",
      "margin-bottom": ".5em"
    },
    attrs: {
      "id": "pAzx"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/part03#pAuMf",
      "id": "d15",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("PART THREE"), _c('br'), _vm._v("\n\t\t\t\t\tCurrent Research")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pAiS3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter09#pAPn3",
      "id": "d16",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter Nine:")]), _vm._v(" Five Best Intergenerational Practices for Small Churches")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pAGo"
    }
  }, [_c('i', [_vm._v("Tori Bennett Smit")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    staticStyle: {
      "margin-top": "0.3em",
      "text-indent": "0"
    },
    attrs: {
      "id": "pAPt"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10#pA3_X",
      "id": "d17",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter Ten:")]), _vm._v(" Well-Being, Discipleship, and Intergenerational Connectedness")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pAThF"
    }
  }, [_c('i', [_vm._v("Joe Azzopardi")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    staticStyle: {
      "margin-top": "0.3em",
      "text-indent": "0"
    },
    attrs: {
      "id": "pAEA"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter11#pAshN",
      "id": "d18",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter Eleven:")]), _vm._v(" All Ages Learning Together")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pA5f"
    }
  }, [_c('i', [_vm._v("Wilson McCoy")])]), _vm._v(" "), _c('p', {
    staticClass: "center",
    staticStyle: {
      "margin-top": "1.5em",
      "margin-bottom": ".5em"
    },
    attrs: {
      "id": "pz8-2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/part04#pA4KI",
      "id": "d19",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("PART FOUR"), _c('br'), _vm._v("\n\t\t\t\t\tIncluding Every Generation")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pAxy"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter12#pAlah",
      "id": "d20",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter Twelve:")]), _vm._v(" Babies and Toddlers, Too?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "AcL3"
    }
  }, [_c('i', [_vm._v("Dawn Rundman")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    staticStyle: {
      "margin-top": "0.3em",
      "text-indent": "0"
    },
    attrs: {
      "id": "pASaH"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter13",
      "id": "d21",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter Thirteen:")]), _vm._v(" Millennials and Screeners")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pASI"
    }
  }, [_c('i', [_vm._v("Dave Sanders")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    staticStyle: {
      "margin-top": "0.3em",
      "text-indent": "0"
    },
    attrs: {
      "id": "pARv"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter14#pAV2p",
      "id": "d22",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter Fourteen:")]), _vm._v(" Welcoming Emerging Adults")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pA5Rn"
    }
  }, [_c('i', [_vm._v("Holly Catterton Allen")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    staticStyle: {
      "margin-top": "0.3em",
      "text-indent": "0"
    },
    attrs: {
      "id": "pAbv"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter15#pAIqP",
      "id": "d23",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter Fifteen:")]), _vm._v(" Engaging the Elders among Us")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pAuHu"
    }
  }, [_c('i', [_vm._v("Diane E. Shallue")])]), _vm._v(" "), _c('p', {
    staticClass: "center",
    staticStyle: {
      "margin-top": "1.5em",
      "margin-bottom": ".5em"
    },
    attrs: {
      "id": "pAy3e"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/part05#pAeGQ",
      "id": "d24",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("PART FIVE"), _c('br'), _vm._v("\n\t\t\t\t\tUnique Ministries and Approaches")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pAG47"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter16#pAxCQ",
      "id": "d25",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter Sixteen:")]), _vm._v(" Exploring Intentionally Intergenerational Environments")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pA80U"
    }
  }, [_c('i', [_vm._v("Tammy Tolman")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    staticStyle: {
      "margin-top": "0.3em",
      "text-indent": "0"
    },
    attrs: {
      "id": "pAvxP"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter17#pAKsf",
      "id": "d26",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter Seventeen:")]), _vm._v(" Faith Storytelling with All Ages")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pAWD"
    }
  }, [_c('i', [_vm._v("Karen DeBoer")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    staticStyle: {
      "margin-top": "0.3em",
      "text-indent": "0"
    },
    attrs: {
      "id": "pAYEY"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter18#pA_W0",
      "id": "d27",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter Eighteen:")]), _vm._v(" Walking beside Each Other")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pAu5"
    }
  }, [_c('i', [_vm._v("Linda Staats")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    staticStyle: {
      "margin-top": "0.3em",
      "text-indent": "0"
    },
    attrs: {
      "id": "pA_2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter19#pAhQ7",
      "id": "d28",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter Nineteen:")]), _vm._v(" The Art of Christian Relationships")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pAKM"
    }
  }, [_c('i', [_vm._v("Liz Perraud")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    staticStyle: {
      "margin-top": "0.3em",
      "text-indent": "0"
    },
    attrs: {
      "id": "pAs3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter20#pAhcV",
      "id": "d29",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter Twenty:")]), _vm._v(" Connecting the Generations through Visual Faith")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pAcT6"
    }
  }, [_c('i', [_vm._v("Nancy S. Going")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    staticStyle: {
      "margin-top": "0.3em",
      "text-indent": "0"
    },
    attrs: {
      "id": "pAr-"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter21#pAqCi",
      "id": "d30",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter Twenty-One:")]), _vm._v(" All-Age Worship")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pAK2"
    }
  }, [_c('i', [_vm._v("Olivia B. Updegrove")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    staticStyle: {
      "margin-top": "0.3em",
      "text-indent": "0"
    },
    attrs: {
      "id": "pA1TG"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/backmatter01",
      "id": "d31",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Conclusion:")]), _vm._v(" The Intergenerationally Sticky Church")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    staticStyle: {
      "margin-bottom": ".9em"
    },
    attrs: {
      "id": "pAYh"
    }
  }, [_c('i', [_vm._v("Cory Seibel")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pz8-4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/backmatter02#pz265-6",
      "id": "d32",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Selected Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    staticStyle: {
      "margin-top": "0.3em",
      "text-indent": "0"
    },
    attrs: {
      "id": "pz8-5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/backmatter03#pz267-6",
      "id": "d33",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("About the Contributors")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21765f78","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/loi.vue
// module id = 69
// module chunks = 0